
// EgresadosRoutes.jsx 
import { Routes, Route, Outlet } from 'react-router-dom';

import { useAuthCuadroMando } from '../context/AuthCuadroMandoContext';
import { PrivateCMILayout } from "./PrivateCMILayout";
import { PublicCMILayout } from "./PublicCMILayout";
import { Suspense } from 'react';

import Home from '../../../pages/Home/Home';
import SingnIn from '../../../pages/Login/SignIn';
import Login from '../../../pages/Login/Login';


import CatalogRouter from '../../../routers/CatalogRouters';

const PrivateCMI = (props) => {
    const { AvailableRoutes } = useAuthCuadroMando(); 
 
    return (
        <Routes> 
            {/* Rutas públicas*/}
            <Route path='/' element={<PublicCMILayout />}>
                <Route path="/solicitud-de-acceso" element={<SingnIn/>} />
                <Route path="/inicio-sesion" element={<Login/>} />
            </Route>

            {/* Rutas privadas */}
            <Route path="/" element={<PrivateCMILayout {...props} />} >
                <Route index element={<Home />} />
                <Route element={<Suspense fallback={<div>Cargando...</div>}><Outlet /></Suspense>}>
                    {AvailableRoutes.map(({ path, componente }) => {
                        const catalogItem = CatalogRouter?.find(item => item.Id === componente);
                        return catalogItem && (
                            <Route
                                key={componente}
                                path={path}
                                element={<catalogItem.Component />}
                            />
                        );
                    })}
                </Route>
                <Route path="*" element={<Home />} />
            </Route>
        </Routes>
    );
};
export default PrivateCMI; 